export default "__VITE_ASSET__pSgG$vSj__"